import { render } from "./ColorLegend.vue?vue&type=template&id=6944d540&scoped=true"
import script from "./ColorLegend.vue?vue&type=script&lang=js"
export * from "./ColorLegend.vue?vue&type=script&lang=js"

import "./ColorLegend.vue?vue&type=style&index=0&id=6944d540&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6944d540"]])

export default __exports__